import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito equipo especial para los ejercicios?',
    answer: 'No. Los movimientos somáticos se pueden hacer en el suelo, en una alfombra o incluso en tu cama. No necesitas pesas ni equipo de gimnasio.'
  }, {
    question: '¿Es una dieta estricta? ¿Pasaré hambre?',
    answer: 'Absolutamente no. El hambre genera estrés, y el estrés genera cortisol. Comerás delicioso, saciante y nutritivo. El objetivo es sanar, no restringir.'
  }, {
    question: '¿Cuánto tiempo necesito al día?',
    answer: 'El protocolo está diseñado para mujeres ocupadas. Necesitas unos 15-20 minutos en total distribuidos durante el día (5 min de movimiento, y el tiempo normal de tus comidas).'
  }, {
    question: '¿Qué pasa si no me funciona?',
    answer: 'Tienes una garantía de 30 días. Si sigues el protocolo y no sientes una mejora en tu hinchazón, energía y bienestar, te devolvemos tu dinero íntegramente.'
  }];
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <h2 className="text-3xl font-serif font-bold text-charcoal text-center mb-12" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-5" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-beige-200 rounded-xl overflow-hidden" data-id="element-6">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 bg-cream-50 hover:bg-cream-100 transition-colors text-left" data-id="element-7">
        <span className="font-bold text-charcoal" data-id="element-8">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-sage-600" data-id="element-9" /> : <ChevronDown className="w-5 h-5 text-sage-600" data-id="element-10" />}
      </button>
      <AnimatePresence data-id="element-11">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-12">
            <div className="p-5 bg-white text-charcoal-light border-t border-beige-100" data-id="element-13">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}